// TASK-10093 — the DispatchAcademy driver training videos, linked from
// the driver side's "Get help" (Driver Code sign-in screen + the driver app's
// Help sheet) so an office can tell a new hire "watch the Academy videos under
// Get help". Chris 2026-10-26.
//
// ONE list. When the remade single "driver app" episode lands, change this
// constant and nothing else. Plain static pages under /marketing/ — public, no
// sign-in, opened in a new tab so the driver's session/screen is untouched.
//
// Exposed as window.DriverAcademy (never cross-import a ?v=-busted module —
// CLAUDE.md Pitfall #1); app.js imports this file once for its side effect.

export const DRIVER_ACADEMY_VIDEOS = Object.freeze([
  Object.freeze({ title: 'Driver App in 3 Minutes', url: '/marketing/training-driver-app.html' }),
  Object.freeze({ title: 'Driver App Extras', url: '/marketing/training-driver-extras.html' }),
]);

export const DRIVER_ACADEMY_LABEL = 'Training videos (Academy)';

// Hardcoded copy only — nothing interpolated comes from user data.
export function driverAcademyLinksHtml({ onDark = false } = {}) {
  const color = onDark ? 'var(--brand-cyan,#06B6D4)' : 'var(--brand-blue,#3B82F6)';
  const items = DRIVER_ACADEMY_VIDEOS.map(v => `
    <a class="driver-academy-link" href="${v.url}" target="_blank" rel="noopener"
       style="display:flex;align-items:center;gap:10px;min-height:44px;padding:8px 4px;text-decoration:none;color:${color};font-weight:600;font-size:0.92rem;">
      <span class="material-icons" aria-hidden="true" style="font-size:22px;">play_circle</span>
      <span style="flex:1;">${v.title}</span>
      <span class="material-icons" aria-hidden="true" style="font-size:16px;opacity:0.7;">open_in_new</span>
    </a>`).join('');
  return `<div class="driver-academy-links" data-driver-academy="1">${items}</div>`;
}

// The Driver Code sign-in screen (index.html #driver-pin-form) carries an empty
// #driver-pin-academy-links slot; fill it once. Module scripts run after the
// document is parsed, so the slot already exists when this executes.
export function fillDriverPinAcademySlot(root = typeof document !== 'undefined' ? document : null) {
  const slot = root && root.getElementById ? root.getElementById('driver-pin-academy-links') : null;
  if (!slot || slot.getAttribute('data-filled') === '1') return false;
  slot.innerHTML = driverAcademyLinksHtml({ onDark: true });
  slot.setAttribute('data-filled', '1');
  return true;
}

if (typeof window !== 'undefined') {
  window.DriverAcademy = Object.freeze({
    videos: DRIVER_ACADEMY_VIDEOS,
    label: DRIVER_ACADEMY_LABEL,
    linksHtml: driverAcademyLinksHtml,
    fillPinSlot: fillDriverPinAcademySlot,
  });
  try { fillDriverPinAcademySlot(); } catch (_) { /* never block sign-in over a help link */ }
}
